export enum ActionButtonEnum {
  // Other Action Buttons
  CancelOrClose = 0,
  Create = 1,
  Update = 2,
  Delete = 3,
  Clear = 4,
  Apply = 5,
  Upload = 6,
  Child = 7,
  Manage = 8,
  MapURL = 9,
  UploadParcels=10,
  CreateAdHocValidParcel=11,
  // Filter Action Buttons
  FilterCancelOrClose = 101,
  FilterReset = 102,
  FilterSubmit = 103
}
